'use strict'
import axios from 'axios'
import Qs from 'qs'
import baseURL from "@/api/baseURL"

// 开发环境 或 部署环境
const _ENV_ = 'PROD' // DEV PROD http://www.hk952183.com:44808 http://localhost:8088 http://47.97.229.242:8088 http://192.168.1.114:8088 http://220.179.147.36:45808

const DEV_URL = '/api'

const PROD_URL = baseURL
//开发请求地址
// const PROD_URL = 'http://www.hk952183.com:44808'
// const PROD_URL = 'http://192.168.1.112:8088'

axios.defaults.baseURL = _ENV_ == 'PROD' ? DEV_URL : PROD_URL

axios.defaults.timeout = 600000

axios.defaults.headers = { 'X-Requested-With': 'XMLHttpRequest' }

const vueSingleton = (() => {
  let unique
  function getInstance() {
    if (unique === undefined) {
      unique = new Construct()
    }
    return unique
  }
  function Construct() {
    return new Vue()
  }
  return {
    getInstance: getInstance
  }
})()

axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '错误请求'
          break
        case 401:
          err.message = '未授权'
          break
        case 403:
          err.message = '拒绝访问'
          break
        case 404:
          err.message = '请求错误,未找到该资源'
          break
        case 405:
          err.message = '请求方法未允许'
          break
        case 408:
          err.message = '请求超时'
          break
        case 500:
          err.message = '服务器端出错'
          break
        case 501:
          err.message = '网络未实现'
          break
        case 502:
          err.message = '网络错误'
          break
        case 503:
          err.message = '服务不可用'
          break
        case 504:
          err.message = '网络超时'
          break
        case 505:
          err.message = 'http版本不支持该请求'
          break
        default:
          err.message = `连接错误${err.response.status}`
      }
    } else {
      err.message = '连接到服务器失败'
    }
    vueSingleton
      .getInstance()
      .$message({ type: 'error', message: err.message, duration: 3 * 1000 })
    return Promise.resolve(err.response)
  }
)

const Http = {}

Http.get = (url, params) => {
  var tempArr = []
  var urlParamsStr
  var token = sessionStorage.getItem('token')
  if (token != null && token != '') {
    tempArr.push('Authorization' + '=' + token)
    urlParamsStr = tempArr.join('&')
  }
  // console.log(urlParamsStr)
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url + '?' + urlParamsStr,
      params: params
    })
      .then(res => {
        resolve && resolve(res.data)
      })
      .catch(error => {
        reject && reject()
      })
  })
}

Http.post = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data: Qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(res => {
        resolve && resolve(res.data)
      })
      .catch(error => {
        reject && reject()
      })
  })
}

Http.jsonPost = (url, params) => {
  var tempArr = []
  var urlParamsStr
  var token = sessionStorage.getItem('token')
  if (token != null && token != '') {
    tempArr.push('Authorization' + '=' + token)
    urlParamsStr = tempArr.join('&')
  }
  // console.log(urlParamsStr)
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url + '?' + urlParamsStr,
      data: Qs.stringify(params),
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
      .then(res => {
        resolve && resolve(res.data)
      })
      .catch(error => {
        reject && reject()
      })
  })
}

Http.formDataPost = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(res => {
        resolve && resolve(res.data)
      })
      .catch(error => {
        reject && reject()
      })
  })
}

Http.listPost = (url, params) => {
  var tempArr = []
  var urlParamsStr
  var token = sessionStorage.getItem('token')
  if (token != null && token != '') {
    tempArr.push('Authorization' + '=' + token)
    urlParamsStr = tempArr.join('&')
  }
  // console.log(urlParamsStr)
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: urlParamsStr?url + '?' + urlParamsStr:url,
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
      .then(res => {
        resolve && resolve(res.data)
      })
      .catch(error => {
        reject && reject()
      })
  })
}
Http.excelPost = (url, params) => {
  var tempArr = []
  var urlParamsStr
  var token = sessionStorage.getItem('token')
  if (token != null && token != '') {
    tempArr.push('Authorization' + '=' + token)
    urlParamsStr = tempArr.join('&')
  }
  // console.log(urlParamsStr)
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url + '?' + urlParamsStr,
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      responseType: 'blob'
    })
      .then(res => {
        resolve && resolve(res.data)
      })
      .catch(error => {
        reject && reject()
      })
  })
}

Http.jsonStrictPost = (url, params, query = {}) => {
  let token = sessionStorage.getItem('token')
  token && (query.Authorization = token)
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url + '?' + Qs.stringify(query),
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
      .then(res => {
        if (res.data.code !== 200) {
          reject && reject(res.data)
        } else {
          resolve && resolve(res.data.content)
        }
      })
      .catch(error => {
        reject && reject()
      })
  })
}
Http.jsonStrictGet = (url, params = {}) => {
  let token = sessionStorage.getItem('token')
  token && (params.Authorization = token)
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url + '?' + Qs.stringify(params),
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
      .then(res => {
        resolve && resolve(res.data.content)
      })
      .catch(error => {
        reject && reject()
      })
  })
}

export default Http
